<template>
  <div class="frame1">
    <div class="frame1_top">
      指数概况
      <img src="../../../../public/img/shares_Info/close.png" alt="" @click="close_prame1"/>
    </div>
    <div class="frame1_content">
      <div class="frame1_content_line1" v-for="(item,index) in intro" :key="'1'+index">
        <div class="frame1_content_line1_text1">{{item[0]}}</div>
        <div class="frame1_content_line1_text2">{{item[1]}}</div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  props:{
    intro:{
      type:Array,
      default(){
        return []
      }
    }
  },
  methods:{
      close_prame1(){
          this.$emit('close_prame1')
      }
  }
};
</script>

<style scoped>
.frame1 {
  width: 448px;
  /* height: 570px; */
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  position: fixed;
  top: calc(50% - 316px);
  left: calc(50% - 260px);
  z-index: 9999999;
  padding: 30px 36px;
}
.frame1_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame1_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame1_content {
  margin-top: 15px;
}
.frame1_content_line1 {
  display: flex;
  line-height: 28px;
}
.frame1_content_line2 {
  display: flex;
  line-height: 28px;
}
.frame1_content_line3 {
  display: flex;
  line-height: 28px;
}
.frame1_content_line3_text1 {
  width: 64px;
  min-width: 64px;
  height: 85px;
  font-size: 16px;
  color: #666666;
}
.frame1_content_line3_text2 {
  margin-left: 35px;
  font-size: 16px;
  color: #333333;
  position: relative;
}
.frame1_content_line3_text3{
    position: absolute;
    right: 0;
    bottom: 2px;
    background-color: #fff;
    cursor: pointer;
}
.frame1_content_line2_box1{
    flex: 1;
    display: flex;
}
.frame1_content_line2_box2{
    flex: 1;
    display: flex;
}
.frame1_content_line1_text1 {
  width: 64px;
  font-size: 16px;
  color: #666666;
}
.frame1_content_line1_text2 {
  margin-left: 35px;
  font-size: 16px;
  color: #333333;
}
.frame1_content_line1_text3 {
  width: 95px;
  font-size: 16px;
  color: #666666;
}
.frame1_content_line1_text4 {
  margin-left: 10px;
  font-size: 16px;
  color: #333333;
}
</style>